import { createContext, useContext } from 'react'

export type ManageBrandDialogValidationMode =
  | 'facebook'
  | 'twitter'
  | 'locations'
  | 'custom_fields'

interface ManageBrandDialogContext {
  isValid: boolean
  setIsValid: (isValid: boolean) => void
  validationMode?: ManageBrandDialogValidationMode
  shouldHighlightMissing: boolean
}

const manageBrandDialogContext = createContext<ManageBrandDialogContext | null>(
  null,
)

export const ManageBrandDialogContextProvider =
  manageBrandDialogContext.Provider

export function useManageBrandDialogContext() {
  const context = useContext(manageBrandDialogContext)

  if (context == null) {
    throw new Error(
      'useManageBrandDialogContext used outside of ManageBrandDialogContext',
    )
  }

  return context
}
